import { Injectable } from '@angular/core';
import { CongratulationsModalComponent } from './congratulations-modal/congratulations-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { RestartModalComponent } from './restart-modal/restart-modal.component';
import { ParkingSlotModalComponent } from './parking-slot-modal/parking-slot-modal.component';
import { PanoViewModalComponent } from './pano-view-modal/pano-view-modal.component';
import { CustomerPlan } from '../models';
import { Subject } from 'rxjs';
import { PlanSeatElementModalComponent } from './plan-seat-element-modal/plan-seat-element-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { UpgradeModalComponent } from './upgrade-modal/upgrade-modal.component';
import { CheckoutModalComponent } from './checkout-modal/checkout-modal.component';
import { GeneralAdmissionModalComponent } from './general-admission-modal/general-admission-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NationalsTermsAndConditionsModalComponent } from './nationals-terms-and-conditions-modal/nationals-terms-and-conditions-modal.component';
import { TwinsWarmWelcomeModalComponent } from './twins-warm-welcome-modal/twins-warm-welcome-modal.component';
import { TwinsFlexAddonsModalComponent } from './twins-flex-addons-modal/twins-flex-addons-modal.component';
import { AddDigitalWalletModalComponent } from './add-digital-wallet-modal/add-digital-wallet-modal.component';
import { TDCTransaction } from '../models/tdc_transaction.model';
import { WarmWelcomeModalComponent } from './warm-welcome-modal/warm-welcome-modal.component';
import { TwinsChoiceModalComponent } from './twins-choice-modal/twins-choice-modal.component';
import { TwinsChoiceAddonsModalComponent } from './twins-choice-addons-modal/twins-choice-addons-modal.component';
import { OpenHousePlanModalComponent } from './open-house-plan-modal/open-house-plan-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  show(ErrorModalComponent: any, arg1: { class: string; initialState: { animated: boolean; keyboard: boolean; ignoreBackdropClick: boolean; message: any; }; }): BsModalRef {
    throw new Error('Method not implemented.');
  }
  bsModalRef: BsModalRef;

  constructor(public modalService: BsModalService) { }

  public congratulationsModal(): void  {
    const config = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(CongratulationsModalComponent, config);
  }

  public checkoutModal() {
    const config = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(CheckoutModalComponent, config);
  }

  public errorModal(errorMessage): void  {
    const initialState = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      message: errorMessage
    };
    this.bsModalRef = this.modalService.show(ErrorModalComponent, { class: 'modal-dialog-centered', initialState });
  }

  public restartModal(planId, interval): void  {
    const resetConfig: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
      initialState: {
        planId,
        interval
      }
    };
    this.bsModalRef = this.modalService.show(RestartModalComponent, resetConfig);
  }

  public parkingSlotModal(success): void  {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
      initialState: {
        success
      }
    };
    this.bsModalRef = this.modalService.show(ParkingSlotModalComponent, config);
  }

  public panoViewModal(seatId): void  {
    let heigh;
    if (this.isMobile() || window.innerWidth < 1200) {
      heigh = document.getElementById('seat-modal').offsetHeight;
    }
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-lg modal-dialog-centered',
      initialState: {
        seatId,
        parentModalHeight: heigh
      }
    };

    this.bsModalRef = this.modalService.show(PanoViewModalComponent, config);
  }

  public planSeatElementModal(customerPlan: CustomerPlan, accordionToggleSubject: Subject<number>): BsModalRef {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: false,
      class: 'modal-dialog-centered',
      initialState: {
        customerPlan,
        accordionToggleSubject
      }
    };

    return this.modalService.show(PlanSeatElementModalComponent, config);
  }

  public generalAdmissionModal() {
    const config = {
      animated: true,
      class: 'modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(GeneralAdmissionModalComponent, config);
  }

  public infoModal() {
    const infoConfig: ModalOptions = {
      animated: true,
      class: 'modal-dialog-centered guide-modal'
    };
    this.modalService.show(InfoModalComponent, infoConfig);
  }

  // public backModal() {
  //   const infoConfig: ModalOptions = {
  //     animated: true,
  //     class: 'modal-dialog-centered'
  //   };
  //   this.modalService.show(BackModalComponent, infoConfig);
  // }

  // public justAddonsModal() {
  //   const infoConfig: ModalOptions = {
  //     animated: true,
  //     class: 'modal-dialog-centered'
  //   };
  //   this.modalService.show(JustAddonsModalComponent, infoConfig);
  // }

  // public guideModal() {
  //   const config: ModalOptions = {
  //     animated: true,
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: 'modal-dialog-centered',
  //   };
  //   this.bsModalRef = this.modalService.show(GuideModalComponent, config);
  // }

  public upgradeModal() {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
    };
    return this.bsModalRef = this.modalService.show(UpgradeModalComponent, config);
  }

  public openHousePlanModal() {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
    };
    return this.bsModalRef = this.modalService.show(OpenHousePlanModalComponent, config);
  }

  public nationalsTC() {
      const config: ModalOptions = {
          animated: true,
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-dialog-centered modal-lg',
      };
      this.bsModalRef = this.modalService.show(NationalsTermsAndConditionsModalComponent, config);
  }

  public twinsWarmWelcome() {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-lg',
    };
    this.bsModalRef = this.modalService.show(TwinsWarmWelcomeModalComponent, config);
  }
  public twinsChoiceModal(fromChoice: boolean, customerPlan: CustomerPlan) {
    const classModal = fromChoice ? 'modal-dialog-centered modal-lg modal-choices choice-modal' : 'modal-dialog-centered modal-lg choice-modal';
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: classModal,
      initialState: {
        fromChoice,
        customerPlan
      }
    };
    this.bsModalRef = this.modalService.show(TwinsChoiceModalComponent, config);
  }

  public TwinsChoiceAddonsModal(customerPlan: CustomerPlan): void  {
    const resetConfig: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
      initialState: {
        customerPlan
      }
    };
    this.bsModalRef = this.modalService.show(TwinsChoiceAddonsModalComponent, resetConfig);
  }

    public WarmWelcome() {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-lg',
    };
    this.bsModalRef = this.modalService.show(WarmWelcomeModalComponent, config);
  }

  public flexAddonsModal(plan): void  {
    const resetConfig: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered',
      initialState: {
        plan
      }
    };
    this.bsModalRef = this.modalService.show(TwinsFlexAddonsModalComponent, resetConfig);
  }

  public addDigitalWalletModal(tdcTransaction: TDCTransaction) {
    const config: ModalOptions = {
      animated: true,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-lg',
      initialState: {
        tdcTransaction
      }
    };
    this.bsModalRef = this.modalService.show(AddDigitalWalletModalComponent, config);
  }



  /**
   * Checks if the navigator it's a mobile
   * @returns boolean
   */
  isMobile(): boolean {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  }
}
